/**
 * Per-user, per-browser boolean flags for UI nudges ("seen", "dismissed").
 * Keyed by user id so another account on the same device starts fresh. Falls
 * back to memory for the session when localStorage is unavailable (private
 * mode). Not a server-side record.
 */
const keyFor = (name: string, id: string) => `visaro.${name}.${id}`;

const inMemory = new Set<string>();

const asId = (userId?: string | number | null): string | null =>
  userId != null && String(userId) !== "" ? String(userId) : null;

export function setUserFlag(name: string, userId?: string | number | null): void {
  const id = asId(userId);
  if (!id) return;
  const key = keyFor(name, id);
  inMemory.add(key);
  try {
    localStorage.setItem(key, "1");
  } catch {
    /* memory fallback covers this session */
  }
}

export function hasUserFlag(name: string, userId?: string | number | null): boolean {
  const id = asId(userId);
  if (!id) return false;
  const key = keyFor(name, id);
  if (inMemory.has(key)) return true;
  try {
    return localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}
